module.exports = __webpack_public_path__ + "img/color-reference.cd472b53.png";